import * as dotenv from 'dotenv'
dotenv.config()

const service = {
  NAME: process.env.REACT_APP_SERVICE_NAME || 'vehicle-submission-web',
}

const authService = {
  URL: process.env.REACT_APP_TS_AUTHENTICATION_URL,
  AUTH_PROJECT: process.env.REACT_APP_AUTH_PROJECT,
}

const restful = {
  URL: process.env.REACT_APP_TS_RESTFUL_API_URL,
  PROJECT: process.env.REACT_APP_SUBMISSION_PROJECT,
}

const uploadService = {
  URL: process.env.REACT_APP_TS_UPLOAD_URL,
}

const social = {
  GOOGLE_APP_ID: process.env.REACT_APP_SOCIAL_GOOGLE_APP_ID || '',
  FACEBOOK_APP_ID: process.env.REACT_APP_SOCIAL_FACEBOOK_APP_ID || '',
  LINE_LOGIN_ID: process.env.REACT_APP_LINE_LOGIN_CLIENT_ID || '',
  LINE_CALLBACK_URL: process.env.REACT_APP_LINE_LOGIN_CALLBACK_URL || '',
  APPLE_LOGIN_ID: process.env.REACT_APP_APPLE_LOGIN_CLIENT_ID || '',
  APPLE_CALLBACK_URL: process.env.REACT_APP_APPLE_LOGIN_CALLBACK_URL || '',
}

const key = {
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
}

const payment = {
  OMISE_PUBLIC_KEY: process.env.REACT_APP_OMISE_PUBLIC_KEY || '',
  WS_API_URL: process.env.REACT_APP_WS_API_URL || process.env.REACT_APP_PUBLIC_API_WS || '',
}

const feature = {
  PRO_FLOW_DEPLOYMENT_DATE:
    process.env.REACT_APP_PRO_FLOW_DEPLOYMENT_DATE || '2026-07-22T16:00:00+07:00',
}

const mcpApi = {
  URL: process.env.REACT_APP_MCP_API_URL || 'https://mcp.haup.ai',
}

const webReserve = {
  URL: 'https://haup.ai',
}

const websocket = {
  HOST: 'websocket.haupcar.com',
  PORT: 443,
  APP_KEY: 'haupcar-websocket-key-9a7f2e1b4c8d',
  ENCRYPTED: true,
  CHANNEL_PREFIX: window.location.hostname === 'my.haupcar.com' ? 'prod' : 'dev',
}

const config = {
  service,
  authService,
  social,
  restful,
  uploadService,
  key,
  mcpApi,
  webReserve,
  websocket,
  payment,
  feature,
}

export default config
